var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosebtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.2588 0.477539H14.7555V7.49182H7.74121V0.477539H0.726562V7.49182H7.74121L7.74084 14.5061H0.726562V64.0098H64.2588V71.024H71.2731V64.0098H64.2588V0.477539Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8936 24.1116H27.0791V28.2971H22.8936V24.1116Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2646 32.4827H27.0791V28.2971H31.2646V32.4827Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4502 32.4827H31.2646V36.6682H27.0791V40.8538H22.8936V45.0393H27.0791V40.8538H31.2646V36.6682H35.4502V40.8538H39.6357V45.0393H43.8213V40.8538H39.6357V36.6682H35.4502V32.4827Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6357 28.2971H35.4502V32.4827H39.6357V28.2971Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6357 28.2971V24.1116H43.8213V28.2971H39.6357Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosebtn);
export default __webpack_public_path__ + "static/media/closebtn.d6595b09a785d885b5db27a04dbeac1b.svg";
export { ForwardRef as ReactComponent };